export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const generateStrongPassword = () => {
  const lowercase = "abcdefghijklmnopqrstuvwxyz";
  const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const numbers = "0123456789";
  const special = "@$!%*?&#";

  const allChars = lowercase + uppercase + numbers + special;
  const length = 12;
  let password = "";

  // Ensure at least one of each type
  password += lowercase[Math.floor(Math.random() * lowercase.length)];
  password += uppercase[Math.floor(Math.random() * uppercase.length)];
  password += numbers[Math.floor(Math.random() * numbers.length)];
  password += special[Math.floor(Math.random() * special.length)];

  // Fill the rest randomly
  for (let i = password.length; i < length; i++) {
    password += allChars[Math.floor(Math.random() * allChars.length)];
  }

  // Shuffle the password so the guaranteed characters aren’t always at the start
  password = password
    .split("")
    .sort(() => 0.5 - Math.random())
    .join("");

  return password;
};


export const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
  const R = 6371; // Radius of earth in km
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((lat1 * Math.PI) / 180) *
    Math.cos((lat2 * Math.PI) / 180) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  const d = R * c;
  return d; // in kilometers
};

export const calculateOffAmount = (originalPrice, offPercentage) => {
  if (!originalPrice || !offPercentage) return originalPrice;
  const discount = (originalPrice * offPercentage) / 100;
  return (originalPrice - discount).toFixed(2); // rounded to 2 decimal places
};


export const convertDuration = (minutes) => {
  if (!minutes || isNaN(minutes)) return "0 min";

  if (minutes >= 60) {
    const hours = Math.floor(minutes / 60);
    const remainingMinutes = minutes % 60;

    // Return "X hr" if no remaining minutes, otherwise "X hr Y min"
    return remainingMinutes === 0
      ? `${hours} hr`
      : `${hours} hr ${remainingMinutes} min`;
  }

  return `${minutes} min`;
};

export const hasActionAccess = (auth, moduleName, subModuleName, actionName) => {
  if (auth?.role !== "staff") return true; // Non-staff always has full access

  return auth?.modules?.some((m) => {
    if (m.name !== moduleName) return false;

    // If no subModule provided → only check module access
    if (!subModuleName) {
      return m.access === true;
    }

    // If subModule exists → check subModule access
    return m.subModules?.some((sub) => {
      if (sub.name !== subModuleName) return false;

      // If no specific action is passed → check only access
      if (!actionName) return sub.access === true;

      // If actionName passed → check inside actions array
      return sub.access === true &&
        sub.actions?.some((a) => a.name === actionName && a.access === true);
    });
  });
};



